export default __webpack_public_path__ + "media/assets/images/NMLS-logo-dark-a2e7ef736bb6c4fb25abdeb6fe04a381.png";